import { Box, SxProps, Typography } from "@mui/material";
import { useTranslation } from "react-i18next"; // Import
import ComercialDrawer from "../../../../../components/pet-beauty/CormercialDrawer";
import ComercialInterfaceHeader from "../../../../../components/comercial/ComercialInterfaceHeader";
import { IServiceStore } from "../../../../../services/api/ServiceStore/types";
import { getLocalStorageItem } from "../../../../../hooks/localStorageHooks";
import { sharedStyles } from "../../../../../styles/shared";
import { priceFormatter } from "../../../../../utils/priceFormatter";
import GalleryImageList from "../../../../../components/comercial/ImageGallery";
import ImageGalleryContainer from "../../../../../components/comercial/ImageGallery/ImageGalleryContainer";
import { LeftMarginBackButton } from "@/components/general/buttons/BackPageButton";
import ImageGalleryContainerApi from "@/components/general/Images/ImageGalleryContainerApi";

const ServiceDetails = () => {
  const { t } = useTranslation();
  const selectedServiceStore: IServiceStore = getLocalStorageItem(
    "selectedServiceStore"
  );


    const weekdayKeys = [
        "sunday",
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
    ];

  const renderServiceData = (
    <>
    <ComercialInterfaceHeader title={t("servicePage.management.details.title")} />
      <Box sx={sharedStyles.verticalContent}>
        <Box>
          <Typography fontWeight="bold" variant="h6" textAlign="center">
            {selectedServiceStore?.Service.name}
          </Typography>
        </Box>
        <Box>
          <Typography fontWeight={500}>{t("servicePage.management.details.descriptionLabel")}</Typography>
          <Typography variant="body1" textAlign="justify">
            {selectedServiceStore?.description.length > 0
              ? selectedServiceStore?.description
              : t("servicePage.management.details.noDescription")}
          </Typography>
        </Box>
      </Box>
    </>
  );

const renderPrices = (
    <>
      <ComercialInterfaceHeader title={t("servicePage.management.details.pricesTitle")} />
      <Box sx={sharedStyles.verticalContent}>
        <Box
          display="flex"
          flexWrap="wrap"
          textAlign="center"
          gap="20px"
          justifyContent="space-around"
        >
        {weekdayKeys.map((key, index) => (
            <Box key={index}>
              <Typography fontWeight={500}>{t(`timeRange.days.${key}`)}</Typography>
              <Typography>{`R$ ${priceFormatter(
                selectedServiceStore.priceDay[index]
              )}`}</Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </>
  );

  const renderImageGallery = (
    <>
     <ComercialInterfaceHeader title={t("servicePage.management.details.galleryTitle")} />
      <ImageGalleryContainerApi images={selectedServiceStore.images ?? []} />
    </>
  );

  const renderServiceDetailsContent = (
    <>
      <LeftMarginBackButton />

      <Box sx={styles.container}>
        {renderServiceData}
        {renderPrices}
        {renderImageGallery}
        {/* {renderSelectedEmployee} */}
      </Box>
    </>
  );

  return (
    <Box sx={sharedStyles.sharedMainContainer}>
      <ComercialDrawer content={renderServiceDetailsContent} />
    </Box>
  );
};

export default ServiceDetails;

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "40px",
  } as SxProps,
};
